<template>
  <v-app>
    <v-content class="panel-background">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>wots nu?</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-card-text>
                  <v-alert
                    v-model="alert"
                    dismissible
                    v-bind:type="alertType"
                  >
                    {{ alertText }}
                  </v-alert>
                </v-card-text>
                <v-form>
                  <v-text-field prepend-icon="person" name="email" label="Enter email"
                                type="email" v-model="email"></v-text-field>
                  <v-text-field id="password" prepend-icon="lock" name="password" label="Enter password"
                                type="password" v-model="password"></v-text-field>
                </v-form>
                <v-card-text>
                  No account? <router-link to="/signup">Sign Up</router-link><br/>
                  Forgot password? <router-link to="/reset">Reset here</router-link><br/>
                  <br/>
                  <span class="grey--text">&copy; 2018 wots.nu</span>
                </v-card-text>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="signIn">Log In</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
const fb = require('../firebase')
export default {
  name: 'UserLogin',
  data () {
    return {
      alert: false,
      alertText: 'hello world',
      alertType: 'error',
      email: '',
      password: ''
    }
  },
  mounted () {
    let user = fb.auth.currentUser
    if (user) {
      this.$router.push({path: '/home'})
    }
  },
  methods: {
    signIn: function () {
      if (this.email === '' || this.password === '') {
        this.alertText = 'Please enter an email address and password.'
        this.alert = true
      } else {
        fb.auth.signInWithEmailAndPassword(this.email, this.password)
          .then(
            (user) => {
              this.alertText = ''
              this.alert = false
              this.$router.push({ path: '/home' })
            },
            (err) => {
              this.alertText = err.message + ' Please try again.'
              this.alert = true
            })
      }
    }
  }
}
</script>

<style scoped>
  .panel-background {
    background: #d5412b;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserLogin.vue